<template>
  <div name="demo-table-add-inline">
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :maxRowspan="maxRowspan"
                :addInlineEventBool="true"
                :editInlineEventBool="true"
                :saveInlineEvent="showFlgDetails"
                :columnEvent="columnEvent" />

    <template v-if="objs.add.rows.length > 0">
      <h3>{{desc.add}}</h3>
      <hrms-table :columns="columns[nowLang].index"
                  :data="objs.add"
                  :maxRowspan="maxRowspan" />
    </template>

    <template v-if="objs.edit.rows.length > 0">
      <h3>{{desc.edit}}</h3>
      <hrms-table :columns="columns[nowLang].index"
                  :data="objs.edit"
                  :maxRowspan="maxRowspan" />
    </template>
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.inlineLabels
let flgRowCondition = false
let mockColumns = mock.columns(labels, 'validate', flgRowCondition)
let mockMaxRowspan = 2
let mockData = mock.dataInline(flgRowCondition)

export default {
  name: 'demo-table-add-inline',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData,
      maxRowspan: mockMaxRowspan,
      objs: {
        add: {
          total: 0,
          rows: []
        },
        edit: {
          total: 0,
          rows: []
        }
      },
      desc: {
        add: '',
        edit: ''
      }
    }
  },
  methods: {
    showFlgDetails (params) {
      var inlineObjs = [{
        flg: 'add',
        desc: 'added'
      }, {
        flg: 'edit',
        desc: 'edited'
      }]
      for (var inlineObj of inlineObjs) {
        var dataRows = params.filter(function (paramRow) {
          return paramRow.flg === inlineObj.flg
        })
        this.objs[inlineObj.flg].total = dataRows.length
        this.objs[inlineObj.flg].rows = dataRows
        var total = dataRows.length
        if (total <= 1) {
          this.desc[inlineObj.flg] = 'Data is ' + inlineObj.desc + ' ' + total + ' row'
        } else {
          this.desc[inlineObj.flg] = 'Data are ' + inlineObj.desc + ' ' + total + ' rows'
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableInlineValidate.vue?5c398019